import { jsx as _jsx } from "react/jsx-runtime";
export function SectionNav({ label, items, current, onSelect, orientation = "row" }) {
    const column = orientation === "column";
    return (_jsx("nav", { "aria-label": label, "data-section-nav": "", "data-layout": column ? "section-nav-column" : undefined, style: column
            ? {
                "--section-nav-dir-narrow": "row",
                display: "flex", flexDirection: "var(--section-nav-dir, column)",
                flexWrap: "wrap", alignItems: "flex-start", flex: "none",
                columnGap: "calc(var(--space-25) + var(--space-025))", rowGap: "var(--space-15)",
            }
            : {
                display: "flex", flexWrap: "wrap", columnGap: "calc(var(--space-25) + var(--space-025))",
                flex: "none", paddingBottom: "var(--space-15)",
                borderBottom: "var(--border-hairline) solid var(--line)",
            }, children: items.map((item) => {
            const here = item.id === current;
            return (_jsx("button", { type: "button", "data-section-link": item.id, "aria-current": here ? "true" : undefined, onClick: () => onSelect?.(item.id), style: {
                    border: "none", margin: 0, padding: 0, background: "transparent", cursor: "pointer",
                    borderRadius: "var(--radius-inline)",
                    fontFamily: "var(--font-sans)",
                    fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
                    fontWeight: here ? "var(--type-body-weight-current)" : "var(--type-body-weight-strong)",
                    color: here ? "var(--ink-1)" : "var(--section-nav-ink, var(--ink-2))",
                    transitionProperty: "color",
                    transitionDuration: "var(--dur-fast)",
                    transitionTimingFunction: "var(--ease-out)",
                }, children: item.label }, item.id));
        }) }));
}
